'use client';
import { windowSafe } from '@s7/platform';

const IDENT = 'SwipeableDrawer';
const safeWindow = windowSafe({
    innerHeight: 1080
});
const defaultProps = {
    snapPoint: 32,
    backdrop: true,
    closeOnClickOutside: true,
    padding: 0,
    radius: '2r',
    disableSwipe: false
};

export { IDENT, defaultProps, safeWindow };
//# sourceMappingURL=SwipeableDrawer.contract.js.map
